export default "__VITE_ASSET__f2cfb7eb__"